export class VendSizeFlavorXrefsFilter {
    public IncludeInactive?: boolean;
}

export default VendSizeFlavorXrefsFilter;